import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import idpLogo from '../assets/IntelliDropLogo.png';
export default function Navbar() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("authTokens");
    handleClose();
    navigate("/login");
  };

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "white", height: 56, boxShadow: "none" }}
    >
      <Toolbar sx={{ color: "black", minHeight: "56px !important" }}>

        {/* Removed Brightspeed Logo */}

        {/* TDP Logo - Moved to the right and 10px up */}
        <Button
          color="inherit"
          onClick={() => navigate("/projects")}
          sx={{ p: 0, minWidth: "auto", ml: 1 }}
        >
          {/* <Box
            component="img"
            src={tdpLogo}
            alt="Home"
            sx={{ height: 36, width: "auto", position: "relative", top: "-4px" }}
          /> */}
        </Button>

        {/* Flex Grow */}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} />

        {/* User Icon with Dropdown */}
        <IconButton
          size="large"
          edge="end"
          sx={{ ml: 0, color: "#1a1a1a" }}
          onClick={handleMenu}
        >
          <AccountCircle sx={{ fontSize: 32 }} />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
